const React = require('react');
const {AdminUserDataLayout} = require('../../../dumb/AdminHelpers/AdminLayout');
const {apiAdminRetailerGet, apiAdminRetailerGlobalConfigGet} = require('../../../../api/admin/retailers');
const {getAdminRetailersLink} = require('../../../../utils/adminLinkCtor');

const DataTab = require('./components/RetailerData');
const BalanceProfile = require('./components/BalanceProfile');
const PaymentHistory = require('./components/PaymentHistory');
const Configs = require('./components/Configs');
const MerchantFeatures = require("./components/MerchantFeatures").default;

const {getUserData} = require("./utils/getUserData");

module.exports = ({params}) => {
  const links = [
    {
      id: 'data',
      title: 'Retailer data'
    }, {
      id: 'merchantFeatures',
      title: 'Merchant Features'
    },
    // {
    //   id: 'balanceProfile',
    //   title: 'Balance profile'
    // }, {
    //   id: 'history',
    //   title: 'Payment history'
    // },
    {
      id: 'configs',
      title: 'CONFIGS AND RULES'
    }
  ];
  const views = {
    data: DataTab,
    merchantFeatures: MerchantFeatures,
    balanceProfile: BalanceProfile,
    history: PaymentHistory,
    configs: Configs
  }

  return (
    <AdminUserDataLayout
      userDataRequest={getUserData}
      backLink={getAdminRetailersLink()}
      params={params}
      links={links}
      views={views}
    />
  )
}
